<template>

 <!-- 签名 -->
 <el-dialog
    v-model="signForm"
    title="签名面板"
    width="500"
    destroy-on-close
    center>
    <span>
      <el-row :gutter="20">
            <el-col :span="14" class="border">
              <vue-esign ref="esign" 
              :width="250" 
              :height="100" 
              isCrop="false" 
              lineWidth="1" 
              lineColor="#FF23000"  />
            </el-col>
            <el-col :span="6">
              <el-button @click="handleReset" type="danger" plain>清空签名</el-button>
            </el-col>
      </el-row>
      

    
    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="signForm = false">取消</el-button>
        <el-button type="success" @click="agreeApplyOK();"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>



  <el-button type="info" plain @click="goBackToList">
    <el-icon><Fold /></el-icon>
    返回列表
  </el-button>

    <!-- 分类表格 -->
    <table class="table caption-top" v-if="applys">
    <caption>
      学习认证申请
    </caption>
    <thead>
      <tr>
        <th scope="col">头像</th>
        <th scope="col">姓名</th>
        <th scope="col">申请时间</th>
        <th scope="col">操作</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="apply in applys" :key="apply.applyId">
        <td><img :src="apply.user.avatar" class="avatar"></td>
        <td>{{ apply.user.nickName }}</td>
        <td>{{ apply.applyTime }}</td>
        <td>
          <el-button type="warning" plain>
            <router-link class="nav-link" :to="{ name: 'CertificaStu', params: { userId: apply.user.id, courseId: apply.courseId } }">
              学情分析
              <el-icon><Avatar /></el-icon>
            </router-link>
          </el-button>
          <el-button type="success" @click="agreeApply(apply.applyId, apply.user.id)" plain>同意<el-icon><Select /></el-icon></el-button>
          <el-button type="danger" plain @click="refuse(apply.applyId, apply.user.id, apply.courseId)">拒绝<el-icon><CloseBold /></el-icon></el-button>

        </td>
      </tr>
    </tbody>

    
  </table>
 

  <nav aria-label="...">
    <ul class="pagination" style="float: center">
      <li class="page-item" @click="click_page(-2)">
        <a class="page-link" href="#">前一页</a>
      </li>
      <li
        :class="'page-item ' + page.is_active"
        v-for="page in pages"
        :key="page.number"
        @click="click_page(page.number)"
      >
        <a class="page-link" href="#">{{ page.number }}</a>
      </li>
      <li class="page-item" @click="click_page(-1)">
        <a class="page-link" href="#">后一页</a>
      </li>
    </ul>
  </nav>
</template>
  
<script setup>

import { ref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import $ from "jquery";
import { useRoute } from "vue-router";
import router from "@/router/index";

let pages = ref([]);

const signForm = ref(false);
const esign = ref();
const courseId = ref();

let current_page = 1;
let total_apply = 0;


const Route = useRoute();
const applys = ref();
const token = localStorage.getItem("token");

const userId = ref();
const applyId = ref();

onMounted(() => {
  // 获取路由参数并设置为 current_page
  courseId.value = Route.params.courseId || '';
  current_page = parseInt(Route.params.page) || 1;
  pullApplys(current_page);
});

const handleReset = () => {
  esign.value.reset();
  }

// 加载课程信息
const pullApplys = (page) => {
  current_page = page;
  $.ajax({
    url: "http://124.222.105.205:5000/api/statistics/getAppList",
    data: {
      courseId: courseId.value,
      page: current_page
    },
    type: "post",
    headers: {
      Authorization: "Bearer " + token,
    },
    success(resp) {
     // console.log(resp.data);
      applys.value = resp.data.list;
      total_apply = resp.data.total;
      udpate_pages();
    },
    error(resp) {
      console.log(resp);
    },
  });
};

const click_page = (page) => {
  if (page === -2) page = current_page - 1;
  else if (page === -1) page = current_page + 1;
  let max_pages = parseInt(Math.ceil(total_apply / 10));

  if (page >= 1 && page <= max_pages) {
    pullApplys(page);
  }
};

const udpate_pages = () => {
  let max_pages = parseInt(Math.ceil(total_apply / 10));
  let new_pages = [];
  for (let i = current_page - 2; i <= current_page + 2; i++) {
    if (i >= 1 && i <= max_pages) {
      new_pages.push({
        number: i,
        is_active: i === current_page ? "active" : "",
      });
    }
  }
  pages.value = new_pages;
  router.push({ name: "ApplyList", params: { page: current_page, courseId: courseId.value } });
};


const refuse = (applyId, userId, courseId) => {
  ElMessageBox.confirm("确认拒绝该申请吗?", "拒绝申请", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
    })
    .then(() => {
        $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/refuseApply",
        type: "post",
        data: {
          applyId: applyId,
          userId: userId,
          courseId: courseId
        },
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
                pullApplys(current_page);    
                
            } else {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "服务器异常!稍后再试!"
            });
        }
    });
        
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消拒绝",
      });
    });
}

const agreeApply = (aId, uId) => {
   applyId.value = aId;
   userId.value = uId;
   signForm.value = true;
}

const agreeApplyOK = () => {
  esign.value.generate().then(res => {
    console.log(res) // base64图片

    var blob = dataURLtoBlob(res);
    var file = blobToFile(blob, 'sign.png');

    var formData = new FormData();
    formData.append('file', file);
    formData.append('courseId', courseId.value);
    formData.append('userId', userId.value);
    formData.append('applyId', applyId.value);

    signForm.value = false;
      $.ajax({
        url: "http://124.222.105.205:5000/api/statistics/agreeApply",
        type: "post",
        data: formData,
        headers: {
          Authorization: "Bearer " + token,
        },
        processData: false, // 告诉jQuery不要去处理发送的数据
        contentType: false, // 告诉jQuery不要去设置Content-Type请求头
        dataType: "text",
        success: function (resp) {
          let result = JSON.parse(resp);
         if (result.code == "200") {
          ElMessage({
            type: "success",
            message: result.msg,
          });
         } else {
          ElMessage({
            type: "error",
            message: result.msg,
          });
         }
         pullApplys(current_page);
        },
        error: function () {
          ElMessage({
            type: "error",
            message: "后端服务器异常!稍后再试!",
          });
        },
      });

  }).catch(() => {
    ElMessage({
        type: "error",
        message: "请填写签名",
    });
    return false;
  })

}


const dataURLtoBlob = (dataurl) => { 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}

const blobToFile = (theBlob, fileName) => {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
}

  const goBackToList = () => {
    window.history.back();
  };
</script>
  
  <style scoped>

  .avatar{
    width: 50px;
  }
</style>